module.exports = __webpack_public_path__ + "img/yummy_200x200.81625831.png";